interface InfoBadgeProps {
  level: string;
  className?: string;
}

export default function InfoBadge({ level, className = "" }: InfoBadgeProps) {
  const style =
    level === "已证实"
      ? "bg-secondary-100 text-secondary-900 border-secondary-300"
      : level === "已被辟谣"
        ? "bg-primary-100 text-primary-900 border-primary-300"
        : "bg-accent-100 text-accent-900 border-accent-300";

  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-xs font-medium whitespace-nowrap ${style} ${className}`}
    >
      <i className="ri-record-circle-line" aria-hidden="true"></i>
      {level}
    </span>
  );
}